import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Header } from "@/components/landing/Header";
import { Footer } from "@/components/landing/Footer";
import { XCircle } from "lucide-react";
import { useSEO } from "@/lib/seo";

export default function PaymentCancel() {
  useSEO({ title: "Checkout Cancelled | Gold Time Jewelry", canonicalPath: "/payment/cancel", noindex: true });
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main data-testid="payment-cancel-page">
      <Header />
      <section className="pt-[164px] pb-24 lg:pt-[196px] lg:pb-32 min-h-[60vh]">
        <div className="max-w-2xl mx-auto px-6 sm:px-8 lg:px-12 text-center">
          <XCircle size={44} strokeWidth={1} className="mx-auto text-neutral-400" />
          <h1 className="font-display text-4xl text-neutral-900 mt-6" data-testid="payment-cancel-heading">
            Checkout cancelled
          </h1>
          <p className="text-neutral-600 mt-3">
            Nothing was charged. Your pieces are still in your cart whenever you're ready.
          </p>
          <div className="mt-8 flex items-center justify-center gap-4">
            <Link
              to="/cart"
              data-testid="payment-cancel-cart"
              className="inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-[#E8CC6E] to-[#C9A227] text-neutral-900 text-sm font-semibold px-8 py-3.5"
            >
              Back to cart
            </Link>
            <Link to="/catalog" className="text-sm font-semibold text-[#C9A227] hover:text-[#A8871B] transition-colors duration-300">
              Keep browsing
            </Link>
          </div>
        </div>
      </section>
      <Footer />
    </main>
  );
}
